// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-us-section {
  padding: 4rem 0;
  margin: 0 auto;
}
.contact-us-section .contact-us-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  margin: 0 auto;
}
.contact-us-section .contact-us-wrap .contact-us-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}
.contact-us-section .contact-us-wrap .contact-us-box .text-img-box {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
}
.contact-us-section .contact-us-wrap .contact-us-box .text-img-box .text-box {
  width: 100%;
  max-width: 41.75rem;
}
.contact-us-section .contact-us-wrap .contact-us-box .text-img-box .text-box .para-text {
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.4;
}
.contact-us-section .contact-us-wrap .contact-us-box .text-img-box .img-box {
  width: 100%;
  max-width: 29.125rem;
  height: 100%;
  max-height: 29.125rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.contact-us-section .contact-us-wrap .contact-us-box .text-img-box .img-box img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}
.contact-us-section .contact-us-wrap .contact-us-box .form-wrap {
  width: 100%;
  max-width: 39.25rem;
  background-color: var(--secondaryMain-1000);
  border-radius: 1.25rem;
  box-shadow: 0px 4px 4px var(--black-250);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  padding: 2rem;
}
.contact-us-section .contact-us-wrap .contact-us-box .form-wrap .form-box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin: 0 -0.75rem;
}
.contact-us-section .contact-us-wrap .contact-us-box .form-wrap .form-box .form-control {
  flex: 0 0 100%;
  max-width: 100%;
  padding: 0 0.75rem;
}
.contact-us-section .contact-us-wrap .contact-us-box .form-wrap .form-box .form-control:nth-child(3), .contact-us-section .contact-us-wrap .contact-us-box .form-wrap .form-box .form-control:nth-child(4) {
  flex: 0 0 50%;
  max-width: 50%;
}
.contact-us-section .contact-us-wrap .contact-us-box .form-wrap .btn-box {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}
.contact-us-section .contact-us-wrap .contact-us-box .form-wrap .contact-us-status-box {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 1.25rem;
  padding: 2rem 0;
  margin: auto;
}
.contact-us-section .contact-us-wrap .contact-us-box .form-wrap .contact-us-status-box .icon-box {
  width: 6rem;
  height: 6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
}
.contact-us-section .contact-us-wrap .contact-us-box .form-wrap .contact-us-status-box .icon-box img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  animation: scaleUp 1s ease-in-out forwards 1;
}
@keyframes scaleUp {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  60% {
    transform: scale(1.2);
    opacity: 1;
  }
  100% {
    transform: scale(1);
  }
}
.contact-us-section .contact-us-wrap .contact-us-box .form-wrap .contact-us-status-box .title-text {
  color: var(--black-1000);
  font-size: 2.25rem;
  font-weight: 700;
  line-height: 1.4;
}
.contact-us-section .contact-us-wrap .contact-us-box .form-wrap .contact-us-status-box .subtitle-text {
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.4;
}
@media screen and (max-width: 991.98px) {
  .contact-us-section {
    padding: 2.5rem 0;
  }
  .contact-us-section .contact-us-wrap .contact-us-box {
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
  }
  .contact-us-section .contact-us-wrap .contact-us-box .text-img-box {
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    gap: 1rem;
  }
  .contact-us-section .contact-us-wrap .contact-us-box .text-img-box .text-box {
    max-width: 28rem;
  }
  .contact-us-section .contact-us-wrap .contact-us-box .text-img-box .text-box .para-text {
    font-size: 1rem;
  }
  .contact-us-section .contact-us-wrap .contact-us-box .text-img-box .img-box {
    max-width: 12rem;
    max-height: 12rem;
  }
  .contact-us-section .contact-us-wrap .contact-us-box .form-wrap {
    border-radius: 1rem;
    padding: 1.5rem;
  }
  .contact-us-section .contact-us-wrap .contact-us-box .form-wrap .form-box {
    margin: 0 -0.5rem;
  }
  .contact-us-section .contact-us-wrap .contact-us-box .form-wrap .form-box .form-control {
    padding: 0 0.5rem;
  }
  .contact-us-section .contact-us-wrap .contact-us-box .form-wrap .btn-box {
    margin-top: 1.25rem;
  }
  .contact-us-section .contact-us-wrap .contact-us-box .form-wrap .contact-us-status-box .icon-box {
    width: 5rem;
    height: 5rem;
  }
  .contact-us-section .contact-us-wrap .contact-us-box .form-wrap .contact-us-status-box .title-text {
    font-size: 1.5rem;
  }
  .contact-us-section .contact-us-wrap .contact-us-box .form-wrap .contact-us-status-box .subtitle-text {
    font-size: 1rem;
  }
}
@media screen and (max-width: 767.98px) {
  .contact-us-section {
    padding: 2rem 0;
  }
  .contact-us-section .contact-us-wrap .contact-us-box .text-img-box .text-box {
    max-width: unset;
  }
  .contact-us-section .contact-us-wrap .contact-us-box .text-img-box .text-box .para-text {
    font-size: 0.875rem;
  }
  .contact-us-section .contact-us-wrap .contact-us-box .text-img-box .img-box {
    max-width: 2.5rem;
    max-height: 2.5rem;
    display: none;
  }
  .contact-us-section .contact-us-wrap .contact-us-box .form-wrap .btn-box {
    margin-top: 1rem;
  }
  .contact-us-section .contact-us-wrap .contact-us-box .form-wrap .contact-us-status-box .icon-box {
    width: 4rem;
    height: 4rem;
  }
  .contact-us-section .contact-us-wrap .contact-us-box .form-wrap .contact-us-status-box .title-text {
    font-size: 1.25rem;
  }
  .contact-us-section .contact-us-wrap .contact-us-box .form-wrap .contact-us-status-box .subtitle-text {
    font-size: 0.875rem;
  }
}
@media screen and (max-width: 639.98px) {
  .contact-us-section {
    padding: 2rem 0;
  }
  .contact-us-section .contact-us-wrap .contact-us-box .form-wrap .form-box .form-control:nth-child(3), .contact-us-section .contact-us-wrap .contact-us-box .form-wrap .form-box .form-control:nth-child(4) {
    flex: 0 0 100%;
    max-width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ContactUsSection/ContactUsStyle.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,gCAAA;EACA,cAAA;AACJ;AACI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AACN;AACM;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AACR;AACQ;EACE,WAAA;EACA,mBAAA;AACV;AACU;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AACZ;AAGQ;EACE,WAAA;EACA,oBAAA;EACA,YAAA;EACA,qBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADV;AAGU;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AADZ;AAMM;EACE,WAAA;EACA,mBAAA;EACA,2CAAA;EACA,sBAAA;EACA,wCAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;AAJR;AAMQ;EACE,WAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;AAJV;AAMU;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AAJZ;AAMY;EAEE,aAAA;EACA,cAAA;AALd;AAUQ;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AARV;AAWQ;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AATV;AAWU;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AATZ;AAWY;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,4CAAA;AATd;AAWc;EACE;IACE,mBAAA;IACA,UAAA;EAThB;EAWc;IACE,qBAAA;IACA,UAAA;EAThB;EAWc;IACE,mBAAA;EAThB;AACF;AAcU;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAZZ;AAeU;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAbZ;AAoBE;EApJF;IAqJI,iBAAA;EAjBF;EAoBI;IACE,2BAAA;IACA,mBAAA;IACA,sBAAA;EAlBN;EAoBM;IACE,8BAAA;IACA,mBAAA;IACA,mBAAA;IACA,SAAA;EAlBR;EAoBQ;IACE,gBAAA;EAlBV;EAoBU;IACE,eAAA;EAlBZ;EAsBQ;IACE,gBAAA;IACA,iBAAA;EApBV;EAwBM;IACE,mBAAA;IACA,eAAA;EAtBR;EAwBQ;IACE,iBAAA;EAtBV;EAwBU;IACE,iBAAA;EAtBZ;EA0BQ;IACE,mBAAA;EAxBV;EA4BU;IACE,WAAA;IACA,YAAA;EA1BZ;EA6BU;IACE,iBAAA;EA3BZ;EA8BU;IACE,eAAA;EA5BZ;AACF;AAmCE;EApNF;IAqNI,eAAA;EAhCF;EAqCQ;IACE,gBAAA;EAnCV;EAqCU;IACE,mBAAA;EAnCZ;EAuCQ;IACE,iBAAA;IACA,kBAAA;IACA,aAAA;EArCV;EA0CQ;IACE,gBAAA;EAxCV;EA4CU;IACE,WAAA;IACA,YAAA;EA1CZ;EA6CU;IACE,kBAAA;EA3CZ;EA8CU;IACE,mBAAA;EA5CZ;AACF;AAmDE;EAjQF;IAkQI,eAAA;EAhDF;EAuDY;IAEE,cAAA;IACA,eAAA;EAtDd;AACF","sourcesContent":[".contact-us-section {\n  padding: 4rem 0;\n  margin: 0 auto;\n\n  .contact-us-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    margin: 0 auto;\n\n    .contact-us-box {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      gap: 1rem;\n\n      .text-img-box {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        gap: 2.5rem;\n\n        .text-box {\n          width: 100%;\n          max-width: 41.75rem;\n\n          .para-text {\n            color: var(--black-1000);\n            font-size: 1.5rem;\n            font-weight: 400;\n            line-height: 1.4;\n          }\n        }\n\n        .img-box {\n          width: 100%;\n          max-width: 29.125rem;\n          height: 100%;\n          max-height: 29.125rem;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n\n          img {\n            width: 100%;\n            height: 100%;\n            object-fit: contain;\n            object-position: center;\n          }\n        }\n      }\n\n      .form-wrap {\n        width: 100%;\n        max-width: 39.25rem;\n        background-color: var(--secondaryMain-1000);\n        border-radius: 1.25rem;\n        box-shadow: 0px 4px 4px var(--black-250);\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n        flex-direction: column;\n        padding: 2rem;\n\n        .form-box {\n          width: 100%;\n          display: flex;\n          flex-wrap: wrap;\n          margin: 0 -0.75rem;\n\n          .form-control {\n            flex: 0 0 100%;\n            max-width: 100%;\n            padding: 0 0.75rem;\n\n            &:nth-child(3),\n            &:nth-child(4) {\n              flex: 0 0 50%;\n              max-width: 50%;\n            }\n          }\n        }\n\n        .btn-box {\n          width: 100%;\n          display: flex;\n          justify-content: center;\n          margin-top: 2rem;\n        }\n\n        .contact-us-status-box {\n          width: 100%;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          flex-direction: column;\n          gap: 1.25rem;\n          padding: 2rem 0;\n          margin: auto;\n\n          .icon-box {\n            width: 6rem;\n            height: 6rem;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            margin-bottom: 1rem;\n\n            img {\n              width: 100%;\n              height: 100%;\n              object-fit: contain;\n              object-position: center;\n              animation: scaleUp 1s ease-in-out forwards 1;\n\n              @keyframes scaleUp {\n                0% {\n                  transform: scale(0);\n                  opacity: 0;\n                }\n                60% {\n                  transform: scale(1.2);\n                  opacity: 1;\n                }\n                100% {\n                  transform: scale(1);\n                }\n              }\n            }\n          }\n\n          .title-text {\n            color: var(--black-1000);\n            font-size: 2.25rem;\n            font-weight: 700;\n            line-height: 1.4;\n          } \n\n          .subtitle-text {\n            color: var(--black-1000);\n            font-size: 1.5rem;\n            font-weight: 400;\n            line-height: 1.4;\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 2.5rem 0;\n\n    .contact-us-wrap {\n      .contact-us-box {\n        justify-content: flex-start;\n        align-items: center;\n        flex-direction: column;\n        \n        .text-img-box {\n          justify-content: space-between;\n          align-items: center;\n          flex-direction: row;\n          gap: 1rem;\n\n          .text-box {\n            max-width: 28rem;\n\n            .para-text {\n              font-size: 1rem;\n            }\n          }\n\n          .img-box {\n            max-width: 12rem;\n            max-height: 12rem;\n          }\n        }\n\n        .form-wrap {\n          border-radius: 1rem;\n          padding: 1.5rem;\n  \n          .form-box {\n            margin: 0 -0.5rem;\n  \n            .form-control {\n              padding: 0 0.5rem;\n            }\n          }\n  \n          .btn-box {\n            margin-top: 1.25rem;\n          }\n\n          .contact-us-status-box {  \n            .icon-box {\n              width: 5rem;\n              height: 5rem;\n            }\n  \n            .title-text {\n              font-size: 1.5rem;\n            } \n  \n            .subtitle-text {\n              font-size: 1rem;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    padding: 2rem 0;\n\n    .contact-us-wrap {\n      .contact-us-box {        \n        .text-img-box {\n          .text-box {\n            max-width: unset;\n\n            .para-text {\n              font-size: 0.875rem;\n            }\n          }\n\n          .img-box {\n            max-width: 2.5rem;\n            max-height: 2.5rem;\n            display: none;\n          }\n        }\n\n        .form-wrap {           \n          .btn-box {\n            margin-top: 1rem;\n          }\n\n          .contact-us-status-box {  \n            .icon-box {\n              width: 4rem;\n              height: 4rem;\n            }\n  \n            .title-text {\n              font-size: 1.25rem;\n            } \n  \n            .subtitle-text {\n              font-size: 0.875rem;\n            }\n          }\n        }\n      }\n    }\n  }\n  \n  @media screen and (max-width: 639.98px) {\n    padding: 2rem 0;\n\n    .contact-us-wrap {\n      .contact-us-box {        \n        .form-wrap {\n          .form-box {\n            .form-control {\n              &:nth-child(3),\n              &:nth-child(4) {\n                flex: 0 0 100%;\n                max-width: 100%;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
